import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/login", { replace: true });
      return;
    }
    const sessionId = m[1];

    (async () => {
      try {
        const r = await api.post("/auth/oauth/session", { session_id: sessionId });
        setUser(r.data.user);
        const dest = r.data.user.role === "corporate" ? "/corporate" : `/rooftop/${r.data.user.assigned_rooftop_id}`;
        window.history.replaceState({}, "", dest);
        nav(dest, { replace: true, state: { user: r.data.user } });
      } catch {
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="h-screen w-screen flex items-center justify-center bg-navy text-white text-xs uppercase tracking-wider font-semibold">
      Finalising sign-in…
    </div>
  );
}
